import StatsCard from "./Cards";
const Card = (props) => {
    if(!props)return;
 const subMenus= props.details?.subMenu.map((subMenu)=>(
        <StatsCard key={subMenu.name} details={subMenu} icon={props.details.icon}/>
    ))
  return (
    <>
        <h1 className="text-3xl text-red-900 font-bold">{props.details.title}</h1>
      <div className="rounded-2xl grid place-items-center bg-white/40 p-8 gap-10  grid-cols-1 md:grid-cols-2">
       {subMenus}
      </div>
    </>
  );
};

export default Card;
